import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import { domainList } from '../../../fixed/domains/domainsLIst'
import { subscriptionsList } from '../../../fixed/subscription/subscriptionsList'
import { fetch } from '../../../utility/helpers/Axios/fetch'
import { getUserData } from '../../../utility/Utils'
import { ContactModal } from '../../components/contactform/ContactModal'
import { CustomDataTable } from '../../components/datatable/CustomDataTable'
import { videosData } from './addons/videosData'
import { VideoView } from './addons/VideoView'
import { DomainForm } from './DomainForm'

export const DomainScreen = () => {

  const [subscriptions, setsubScriptions] = useState([])
  const source = require('@src/assets/images/backgrounds/nologo.png').default

  const loadSubscriptions = async () => {
    const subscriptions = await fetch('Subscriptions', null, { extraUrl: `user/${getUserData().id}` })
    setsubScriptions(subscriptions)
  }

  useEffect(() => {
    loadSubscriptions()
  }, [])

  //TODO unificar listados de dominos y subscriciones y dejar que todo el mundo pueda pedir ampliaciones y acceder a la vista
  return (
    <div className='row'>
      {/* <CustomDataTable title="Mis dominios" data={domains} columns={domainList}/> */}
      <div className=' col-12'>
        <CustomDataTable className="h-100" title="Suscripciones" data={subscriptions} columns={subscriptionsList} />
      </div>
      <div className=" col-12" style={{ marginTop: '80px' }}>
        <Card className="h-100">
          <CardBody className="text-center row" >
            <div className='col-12 mb-2'>
              <h1 className='mb-1'>Klinnic Academy</h1>
              Sácale el máximo partido a Klinnic aprendiendo paso a paso todo lo necesario sobre su funcionamiento.
            </div>
            {
              videosData.map((video, index) => <VideoView video={video} key={index + video.id} />)
            }

          </CardBody>
        </Card>
      </div>
    </div >
  )
}
